import React from "react";
import { Icon } from "@iconify/react";

const AffiliatesIcon = () => (
  <Icon icon="lucide:handshake" width={18} height={18} />
);

export default AffiliatesIcon;
